module.exports = __webpack_public_path__ + "eab8c7def5f044c1e62f298f50dcb038.pdf";